if (!customElements.get('media-gallery')) {
  customElements.define('media-gallery', class MediaGallery extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        liveRegion: this.querySelector('[id^="GalleryStatus"]'),
        viewer: this.querySelector('[id^="GalleryViewer"]'),
        thumbnails: this.querySelector('[id^="GalleryThumbnails"]')
      }
      this.mql = window.matchMedia('(min-width: 750px)');
      if (!this.elements.thumbnails) return;

      this.elements.viewer.addEventListener('slideChanged', debounce(this.onSlideChanged.bind(this), 500));
      this.elements.thumbnails.querySelectorAll('[data-target]').forEach((mediaToSwitch) => {
        mediaToSwitch.querySelector('button').addEventListener('click', this.setActiveMedia.bind(this, mediaToSwitch.dataset.target, false));
      });
      if (this.dataset.desktopLayout.includes('thumbnail') && this.mql.matches) this.removeListSemantic();
    }

    onSlideChanged(event) {
      const thumbnail = this.elements.thumbnails.querySelector(`[data-target="${ event.detail.currentElement.dataset.mediaId }"]`);
      this.setActiveThumbnail(thumbnail);
    }

    setActiveMedia(mediaId, prepend) {
      const activeMedia = this.elements.viewer.querySelector(`[data-media-id="${ mediaId }"]`);
      this.elements.viewer.querySelectorAll('[data-media-id]').forEach((element) => {
        element.classList.remove('is-active');
      });
      activeMedia.classList.add('is-active');

      if (prepend) {
        activeMedia.parentElement.prepend(activeMedia);
        if (this.elements.thumbnails) {
          const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
          activeThumbnail.parentElement.prepend(activeThumbnail);
        }
        if (this.elements.viewer.slider) this.elements.viewer.resetPages();
      }

      this.preventStickyHeader();
      window.setTimeout(() => {
        if (this.elements.thumbnails) {
          activeMedia.parentElement.scrollTo({ left: activeMedia.offsetLeft });
        }
        if (!this.elements.thumbnails || this.dataset.desktopLayout === 'stacked') {
          activeMedia.scrollIntoView({behavior: 'smooth'});
        }
      });
      this.playActiveMedia(activeMedia);

      if (!this.elements.thumbnails) return;
      const activeThumbnail = this.elements.thumbnails.querySelector(`[data-target="${ mediaId }"]`);
      this.setActiveThumbnail(activeThumbnail);
      this.announceLiveRegion(activeMedia, activeThumbnail.dataset.mediaPosition);
    }

    setActiveThumbnail(thumbnail) {
      if (!this.elements.thumbnails || !thumbnail) return;

      this.elements.thumbnails.querySelectorAll('button').forEach((element) => element.removeAttribute('aria-current'));
      thumbnail.querySelector('button').setAttribute('aria-current', true);
      if (this.elements.thumbnails.isSlideVisible(thumbnail, 10)) return;

      this.elements.thumbnails.slider.scrollTo({ left: thumbnail.offsetLeft });
    }

    announceLiveRegion(activeItem, position) {
      const image = activeItem.querySelector('.product__modal-opener--image img');
      if (!image) return;
      image.onload = () => {
        this.elements.liveRegion.setAttribute('aria-hidden', false);
        this.elements.liveRegion.innerHTML = window.accessibilityStrings.imageAvailable.replace(
          '[index]',
          position
        );
        setTimeout(() => {
          this.elements.liveRegion.setAttribute('aria-hidden', true);
        }, 2000);
      };
      image.src = image.src;
    }

    playActiveMedia(activeItem) {
      window.pauseAllMedia();
      const deferredMedia = activeItem.querySelector('.deferred-media');
      if (deferredMedia) deferredMedia.loadContent(false);
    }

    preventStickyHeader() {
      this.stickyHeader = this.stickyHeader || document.querySelector('sticky-header');
      if (!this.stickyHeader) return;
      this.stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
    }

    removeListSemantic() {
      if (!this.elements.viewer.slider) return;
      this.elements.viewer.slider.setAttribute('role', 'presentation');
      this.elements.viewer.sliderItems.forEach(slide => slide.setAttribute('role', 'presentation'));
    }
  });
}

/* =========================================================
   ShadeCentral v8 – colour-aware gallery
   - Photos carry data-sc-colour (from alt "Product – Colour"); a variant's own
     photo counts as that colour too. Choosing a colour shows only that
     colour's photos plus shared ones (lifestyle, case, detail).
   - Tap/click a thumbnail or swipe to a colour photo and the colour follows.
   - "Colour: X" in the picker label, X as a caption under the gallery.
   ========================================================= */
(function () {
  if (window.__scVariantSync) return;
  window.__scVariantSync = true;

  function debounce(fn, wait) {
    var t;
    return function () { var a = arguments, c = this; clearTimeout(t); t = setTimeout(function () { fn.apply(c, a); }, wait); };
  }

  function init() {
    var VR = customElements.get('variant-radios');
    if (VR && !VR.prototype.__scPatched) {
      var origUpdateMedia = VR.prototype.updateMedia;
      VR.prototype.updateMedia = function () {
        if (this.__scSkipMedia) return;
        return origUpdateMedia.apply(this, arguments);
      };
      VR.prototype.__scPatched = true;
    }

    document.querySelectorAll('variant-radios').forEach(function (picker) {
      if (picker.__scBound) return;
      picker.__scBound = true;

      var sectionId = picker.dataset.section;
      var variants;
      try { variants = JSON.parse(picker.querySelector('script[type="application/json"]').textContent); } catch (e) { return; }

      var fieldsets = function () { return Array.prototype.slice.call(picker.querySelectorAll('fieldset')); };
      function selectedValues() {
        return fieldsets().map(function (fs) { var c = fs.querySelector('input[type="radio"]:checked'); return c ? c.value : null; });
      }
      function currentVariant() {
        var cur = selectedValues();
        for (var i = 0; i < variants.length; i++) {
          if (variants[i].options.every(function (o, k) { return o === cur[k]; })) return variants[i];
        }
        return null;
      }
      // colour option = the fieldset that has swatches (or the first one)
      var colourIndex = 0;
      fieldsets().forEach(function (fs, i) { if (fs.querySelector('label.sc-swatch') && colourIndex === 0 && i > 0) colourIndex = i; });
      var mediaColour = {};
      variants.forEach(function (v) { if (v.featured_media) mediaColour[String(v.featured_media.id)] = v.options[colourIndex]; });

      var galleries = Array.prototype.slice.call(document.querySelectorAll('[id^="MediaGallery-' + sectionId + '"]'));
      var caption = document.getElementById('GalleryCaption-' + sectionId);

      function updateLegend() {
        fieldsets().forEach(function (fs) {
          var checked = fs.querySelector('input[type="radio"]:checked');
          var span = fs.querySelector('.sc-selected-value');
          if (checked && span) span.textContent = checked.value;
        });
      }

      function applyFilter() {
        var colour = selectedValues()[colourIndex];
        if (caption) caption.textContent = colour || '';
        galleries.forEach(function (gallery) {
          var viewer = gallery.querySelector('[id^="GalleryViewer"]');
          var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
          var items = Array.prototype.slice.call(gallery.querySelectorAll('li[data-media-id], li[data-target]'));
          var shown = 0;
          items.forEach(function (li) {
            var raw = li.dataset.mediaId || li.dataset.target || '';
            var id = raw.replace(sectionId + '-', '');
            var c = li.dataset.scColour || mediaColour[id] || '';
            var hide = !!(colour && c && c !== colour);
            li.classList.toggle('sc-hidden', hide);
            if (!hide && li.dataset.mediaId) shown++;
          });
          gallery.classList.toggle('sc-single', shown <= 1);
          if (viewer && viewer.resetPages) { try { viewer.resetPages(); } catch (e) {} }
          if (thumbs && thumbs.resetPages) { try { thumbs.resetPages(); } catch (e) {} }
        });
      }

      function selectVariantForMedia(rawId) {
        if (!rawId) return;
        var id = String(rawId).replace(sectionId + '-', '');
        var li = null;
        galleries.forEach(function (g) { li = li || g.querySelector('[data-media-id="' + sectionId + '-' + id + '"]'); });
        var colour = (li && li.dataset.scColour) || mediaColour[id];
        if (!colour) return;
        var cur = selectedValues();
        if (cur[colourIndex] === colour) return;
        // choose the variant with this colour that keeps other options if possible
        var target = null;
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          if (v.options[colourIndex] !== colour) continue;
          if (!target) target = v;
          if (v.options.every(function (o, k) { return k === colourIndex || o === cur[k]; })) { target = v; break; }
        }
        if (!target) return;
        var changed = false;
        fieldsets().forEach(function (fs, i) {
          var input = Array.prototype.slice.call(fs.querySelectorAll('input[type="radio"]')).filter(function (inp) { return inp.value === target.options[i]; })[0];
          if (input && !input.checked) { input.checked = true; changed = true; }
        });
        if (!changed) return;
        picker.__scSkipMedia = true;
        picker.dispatchEvent(new Event('change', { bubbles: true }));
        picker.__scSkipMedia = false;
      }

      galleries.forEach(function (gallery) {
        var viewer = gallery.querySelector('[id^="GalleryViewer"]');
        var thumbs = gallery.querySelector('[id^="GalleryThumbnails"]');
        if (thumbs) thumbs.querySelectorAll('[data-target]').forEach(function (t) {
          var btn = t.querySelector('button');
          if (btn) btn.addEventListener('click', function () { selectVariantForMedia(t.dataset.target); });
        });
        if (viewer) viewer.addEventListener('slideChanged', debounce(function (e) {
          var el = e.detail && e.detail.currentElement;
          if (el && el.dataset && el.dataset.mediaId) selectVariantForMedia(el.dataset.mediaId);
        }, 350));
      });

      picker.addEventListener('change', function () { updateLegend(); setTimeout(applyFilter, 0); });
      updateLegend();
      applyFilter();
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
